import type { URLSearchParamsInit } from 'react-router';
import { createSearchParams } from 'react-router';

export function mergeSearchParams(...searchParams: URLSearchParamsInit[]) {
  if (searchParams.length === 1) {
    return createSearchParams(searchParams[0]);
  }

  const merged = new URLSearchParams();
  for (const searchParam of searchParams) {
    for (const [name, value] of createSearchParams(searchParam).entries()) {
      if (!merged.getAll(name).includes(value)) {
        merged.append(name, value);
      }
    }
  }
  return merged;
}
